import { API } from 'aws-amplify';
import { API_NAME, getConfig, validateResponse, handleError } from './apiUtils';

// country api
export async function getCountry(country) {
    const path = `/v1/nbaadmin/${country}/nba-country`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function createCountry(countryCode, countryName) {
    const path = `/v1/nbaadmin/${countryCode}/nba-country`;

    return getConfig({ countryName })
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// entity attribute api
export async function getEntityAttribute(country) {
    const path = `/v1/nbaadmin/${country}/nba-entity-attribute`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// action list
export async function getActionList(country) {
    const path = `/v1/nbaadmin/${country}/nba-action`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

// rules
export async function createRule(country, body) {
    const path = `/v1/nbaadmin/${country}/rule`;

    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function getRule(country, ruleId) {
    const path = `/v1/nbaadmin/${country}/rule/${ruleId}`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

//mycode
export async function getWeight(country,brand) {
    const path = `/v2/nba/${country}/${brand}/market-weight`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function getWeightById(country,brand, goalId) {
    const path = `/v2/nba/${country}/${brand}/market-weight/${goalId}`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function createGoal(country, brand, body) {
    const path = `/v2/nba/${country}/${brand}/market-weight`;

     return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function updateGoal(country, brand, goalId, body) {
    const path = `/v2/nba/${country}/${brand}/market-weight/${goalId}`;

    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function updateGoalStatus(country, brand, goalId, status) {
    const path = `/v2/nba/${country}/${brand}/market-weight/${goalId}`;

    return getConfig({ goalStatus: status })
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function deleteGoal(country, goalId) {
    const path = `/v2/nba/${country}/weight/${goalId}`;

    return getConfig()
        .then((config) => API.del(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
//mycode ends here 
export async function getRuleList(country) {
    const path = `/v1/nbaadmin/${country}/rule`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function updateRule(country, ruleId, body) {
    const path = `/v1/nbaadmin/${country}/rule/${ruleId}`;

    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
export async function deleteRule(country, ruleId) {
    const path = `/v1/nbaadmin/${country}/rule/${ruleId}`;

    return getConfig()
        .then((config) => API.del(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export async function getProducts(country, brand) {
    const path = `/v2/nba/${country}/${brand}/market-weight/product-catalogue-list`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
